import Fetch, { V1, V2 } from 'Util/fetcher';
import { errorLogger } from '@ajaibid/utils';
import { DEFAULT_GET_RESPONSE } from '@config/constanta';

export const getDetailMFTransactionDeposit = (id) => {
  const resourceUrl = `${V2}transactions/deposits/${id}/`;
  return Fetch.get(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const getDetailMFTransactionWithdraw = (id) => {
  const resourceUrl = `${V2}transactions/withdrawals/${id}/`;
  return Fetch.get(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const getDetailMF = (id) => {
  const resourceUrl = `${V2}funds/fund-bundle/${id}/`;
  return Fetch.get(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const getSearchMF = (text) => {
  const resourceUrl = `${V1}mutualfund/fund-bundle/search/?search=${text}`;
  return Fetch.get(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};
